import { render } from "./CertificatesSection.vue?vue&type=template&id=08e56fa3&scoped=true&lang=true"
import script from "./CertificatesSection.vue?vue&type=script&lang=js"
export * from "./CertificatesSection.vue?vue&type=script&lang=js"

import "./CertificatesSection.vue?vue&type=style&index=0&id=08e56fa3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e56fa3"]])

export default __exports__